import {animate, state, style, transition, trigger} from "@angular/animations";

export const HEIGHT_SMOOTH_ANIMATION = trigger('heightSmooth', [
  state('open', style({
    height: '*',
    opacity: '1'
  })),
  state('close', style({
    height: '0px',
    opacity: '0'
  })),
  transition('open => close', [
    animate('0.2s ease')
  ]),
  transition('close => open', [
    animate('0.2s ease')
  ])
])
